import EmbeddedPublicationDirector from './EmbeddedPublicationDirector';

export default EmbeddedPublicationDirector;
